export default __webpack_public_path__ + "static/button-and-icon-66382a04ae5174f67eda2b191d0a9f61cd733f180fe3d4b2151205929390edc1.png";